export default "<hr [ngClass]=\"loading$ | async\">\n";